// Runtime config - loaded from /config.json at startup
// To change API URLs, just edit config.json on the server. No rebuild needed.

interface RuntimeConfig {
  REACT_APP_API: string;
  REACT_APP_AI_API: string;
}

let _config: RuntimeConfig | null = null;
let _loadPromise: Promise<RuntimeConfig> | null = null;

// Normalize: ensure URL ends with /api
const ensureApi = (url: string): string => url.replace(/\/api\/?$/, '').replace(/\/$/, '') + '/api';

export async function loadConfig(): Promise<RuntimeConfig> {
  if (_config) return _config;
  if (_loadPromise) return _loadPromise;

  _loadPromise = (async () => {
    try {
      const res = await fetch('/config.json?t=' + Date.now());
      if (res.ok) {
        const json = await res.json();
        _config = {
          REACT_APP_API: ensureApi(json.REACT_APP_API || process.env.REACT_APP_API || 'https://api.whalasi.xyz/api'),
          REACT_APP_AI_API: ensureApi(json.REACT_APP_AI_API || process.env.REACT_APP_AI_API || 'https://api.whalasi.xyz/api'),
        };
        console.log('✅ Runtime config loaded from config.json');
      } else {
        throw new Error('config.json not found');
      }
    } catch {
      // Fallback to build-time env vars
      _config = {
        REACT_APP_API: ensureApi(process.env.REACT_APP_API || 'https://api.whalasi.xyz/api'),
        REACT_APP_AI_API: ensureApi(process.env.REACT_APP_AI_API || 'https://api.whalasi.xyz/api'),
      };
      console.log('⚠️ Using build-time env vars (config.json not available)');
    }
    console.log('🔧 API_BASE:', _config!.REACT_APP_API);
    console.log('🔧 AI_API_BASE:', _config!.REACT_APP_AI_API);
    // Web build marker — bump on each web ship so we can confirm in the
    // console exactly which bundle is live (ends the "is the web build
    // deployed?" guessing, mirroring backend /api/health buildVersion).
    console.log('🏗️ WEB BUILD:', '2026-06-08-palletfix-14');
    return _config!;
  })();

  return _loadPromise;
}

// Sync getter - returns config after loadConfig() has been called
export function getConfig(): RuntimeConfig {
  if (!_config) {
    // Fallback if called before load (shouldn't happen)
    return {
      REACT_APP_API: ensureApi(process.env.REACT_APP_API || 'https://api.whalasi.xyz/api'),
      REACT_APP_AI_API: ensureApi(process.env.REACT_APP_AI_API || 'https://api.whalasi.xyz/api'),
    };
  }
  return _config;
}

// QUARANTINED 2026-05-20: helper added so components don't hardcode trycloudflare URLs.
// Returns the resolved API base URL from runtime config (with safe build-time fallback).
export function getApiBase(): string {
  return getConfig().REACT_APP_API;
}

// QUARANTINED 2026-05-20: helper added so components don't hardcode trycloudflare URLs.
// Returns the resolved AI API base URL from runtime config (with safe build-time fallback).
export function getAiApiBase(): string {
  return getConfig().REACT_APP_AI_API;
}
